import { styled } from '@mui/material/styles';
import { AppBar, Button, Dialog, Icon, Toolbar, Typography } from '@mui/material';
import { isDark } from 'global/styles';

// Layout + form class overrides (Form uses string class names).
export const TaskCreateDialog = styled(Dialog)(({ theme }) => ({
  zIndex: '1000 !important',
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  '& .MuiAppBar-root': {
    flexShrink: 0,
  },
  '& .MuiDialogContent-root': {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  '& .globalForm-formScrollContainer': {
    height: 'auto !important',
    overflowY: 'visible !important',
  },
  '& div:has(> .globalForm-formScrollContainer)': {
    height: 'auto !important',
  },
  '& .task-create-form-style': {
    position: 'relative',
    width: '100% !important',
    maxWidth: '100% !important',
    overflow: 'hidden !important',
    height: 'auto',
  },
  '& .task-create-title-style': {
    fontSize: '18px !important',
    fontWeight: 'bold',
  },
  '& .task-create-screen-width': {
    width: '100%',
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: 'none !important',
    },
  },
  '& .task-create-screen-container': {
    maxWidth: 'none !important',
  },
  '& .task-create-screen-container-mobile': {
    maxWidth: 'none !important',
  },
}));

// Form/DropZone className constants
export const TC_FORM_STYLE = 'task-create-form-style';
export const TC_TITLE_STYLE = 'task-create-title-style';
export const TC_SCREEN_WIDTH = 'task-create-screen-width';
export const TC_SCREEN_CONTAINER = 'task-create-screen-container';
export const TC_SCREEN_CONTAINER_MOBILE = 'task-create-screen-container-mobile';

export const StyledAppBar = styled(AppBar)({
  position: 'relative',
});

export const StyledToolbar = styled(Toolbar)({
  height: 70,
});

export const Title = styled(Typography)({
  margin: 0,
  padding: 0,
  lineHeight: 1.2,
  fontWeight: 'bold',
});

export const Status = styled(Typography)({
  fontWeight: 'bold',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  display: 'flex',
});

export const StatusIcon = styled('span')(({ theme }) => ({
  marginLeft: theme.spacing(2),
  display: 'inline-flex',
  alignItems: 'center',
}));

export const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  width: '80%',
  maxWidth: 600,
  margin: '0 auto',
}));

export const BarTitle = styled('div')(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  marginLeft: theme.spacing(2),
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(1),
}));

export const TagButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isRemove',
})(({ theme, isRemove }) => ({
  color: theme.palette.secondary.main,
  borderColor: theme.palette.secondary.main,
  ...(isRemove
    ? {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
      }
    : {}),
}));

export const TagContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});

export const TagReference = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: isDark(theme) ? theme.palette.common.white : theme.palette.secondary.main,
}));

export const SuperText = styled('div')({
  fontSize: 16,
  fontWeight: 'bold',
});

export const TagText = styled('p')({
  fontSize: 14,
});

export const TagOption = styled('span')({});

export const TagBox = styled('span')({
  margin: 4,

  '& .MuiSvgIcon-root': {
    marginBottom: -7,
  },
});

export const TagName = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  marginRight: theme.spacing(1),
}));

export const TagDescription = styled('span')({});

export const TagLink = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const SubmitButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(1),

  '& button': {
    marginLeft: theme.spacing(2),
  },
}));

export const SubmitButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'disabledLook',
})(({ theme, disabledLook }) => ({
  ...(disabledLook ? { opacity: 0.5 } : {}),

  '& .MuiButton-startIcon': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    marginRight: theme.spacing(1),
    '& .MuiIcon-root:first-of-type': {
      fontSize: 24,
    },
  },
}));

export const DoubleIcon = styled('div')({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
});

export const SubscriptAddIcon = styled(Icon)({
  position: 'absolute',
  bottom: 0,
  right: -4,
  fontSize: '14px !important',
  lineHeight: 1,
});

export const SubmitBtnText = styled('span')({
  whiteSpace: 'nowrap',
});

// Loading container for the form-loading state (centered)
export const LoadingContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  width: '80%',
  maxWidth: 600,
  margin: '0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
}));
